import React from 'react';
import { formatCurrency } from '@/utils/formatters';
import { DEFAULT_CATEGORIES } from '@/constants';

const CAT_MAP = Object.fromEntries(DEFAULT_CATEGORIES.map(c => [c.id, c]));

export default function BudgetImpactPanel({ category, amount, categoryStatus, budget }) {
  const cat    = CAT_MAP[category];
  const status = categoryStatus?.[category];
  const overall = budget ? (budget.totalBudget - Object.values(categoryStatus ?? {}).reduce((s, v) => s + v.spent, 0)) : null;

  return (
    <div
      className="absolute bottom-16 left-0 right-0 bg-white rounded-t-2xl shadow-2xl
                 p-4 slide-up z-30"
      role="region"
      aria-label="Budget impact"
    >
      <h3 className="text-sm font-bold text-gray-800 mb-3 flex items-center gap-2">
        ⚡ Budget Impact
      </h3>

      {status && (
        <div className="space-y-2">
          <div className="flex justify-between text-xs py-1.5 border-b border-gray-100">
            <span className="text-gray-500">
              {cat?.emoji} {cat?.label ?? category} total
            </span>
            <span className={`font-bold ${status.status === 'danger' ? 'text-danger' : status.status === 'warning' ? 'text-yellow-700' : 'text-success'}`}>
              {formatCurrency(status.spent)} / {formatCurrency(status.budget)}
            </span>
          </div>
          <div className="flex justify-between text-xs py-1.5 border-b border-gray-100">
            <span className="text-gray-500">Status</span>
            <span className={`font-bold ${status.status === 'danger' ? 'text-danger' : status.status === 'warning' ? 'text-yellow-700' : 'text-success'}`}>
              {status.status === 'danger' ? `🔴 Over by ${formatCurrency(status.spent - status.budget)}` :
               status.status === 'warning' ? `🟡 ${Math.round(status.percent)}% used` :
               `✓ ${formatCurrency(status.remaining)} remaining`}
            </span>
          </div>
          {overall !== null && (
            <div className="flex justify-between text-xs py-1.5">
              <span className="text-gray-500">Overall remaining</span>
              <span className={`font-bold ${overall >= 0 ? 'text-success' : 'text-danger'}`}>
                {formatCurrency(overall)} {overall >= 0 ? '✓' : '🔴'}
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
